module.exports = __webpack_public_path__ + "static/domestic_mental_obj02_m@2x-11e174189531e36cbb4a6a598a096100.jpg";